<template>
    <div class="button-group">
        <button v-show="!object.id" class="btn btn-success" @click="save"><i class="cil-save"> </i> Save</button>
        <button v-show="object.id" class="btn btn-success" @click="update"><i class="cil-cloud-upload"> </i> Update</button>
        <button class="btn btn-warning" @click="reset"><i class="cil-reload"> </i> Reset</button>
    </div>
</template>

<script>
    export default {
        name: "SURButton",
        props: ['object'],
        methods: {
            save(evt) {
                this.$emit('onSave', evt);
            },
            update(evt) {
                this.$emit('onUpdate', evt);
            },
            reset(evt) {
                this.$emit('onReset', evt);
            }
        }
    }
</script>
